import React, { useEffect, useState } from "react";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import "./ApplicationMaster.css";
import { useNavigate } from "react-router-dom";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  GetDropDownList,
  ApplicationExportToExcel,
  getApplicationMasterGridData,
} from "../../../Helpers/API/APIEndPoints";
import Heading from "../../../Components/Heading/Heading";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import fileDownload from "js-file-download";
import axios from "axios";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import { Tooltip } from "antd";

const ApplicationMaster = () => {
  let navigate = useNavigate();

  const [applicationData, setApplicationData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [engagement, setEngagement] = useState<any>(JSON.parse(localStorage.getItem("engagement") || "{}"));   //deepak gupta
  const [onFilter, setOnFilter] = useState(false);
  const [reset, setReset] = useState(false);
  const [isactive, setIsActive] = useState("active");
  const [applicationEngagementOption, setApplicationEngagementOption] =
    useState<any>([]);

       //deepak gupta
    useEffect(() => {
      localStorage.setItem("engagement",JSON.stringify(engagement));
    }, [engagement]);


  // Added custom color for tooltip
  const customColors = ["#2755f3"];

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "application",
      label: "Application",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "engagementName",
      label: "Engagement",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "isActive",
      label: "Active",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          if (value) {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let id = tableMeta.tableData[tableMeta.rowIndex].id;

          return (
            <>
              <Tooltip title="Edit" color={customColors[0]}>
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("edit", { state: id });
                  }}
                  className="action_icon"
                >
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                </a>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];
  useEffect(() => {

       //deepak gupta
    const clearUnwantedLocalStorage = () => {
      const keysToKeep = ["engagement"];
      Object.keys(localStorage).forEach((key) => {
        if (!keysToKeep.includes(key)) {
          localStorage.removeItem(key);
        }
      });
    };

    (async () => {
      // let requestParams = {
      //   start: start,
      //   pageSize: pageSize,
      //   sortColumn: sortColumn,
      //   sortDirection: sortDirection,
      //   searchText: searchText,
      //   engagementFilterOption : engagement.value
      // };

      // const { data } = await APICall(
      //   getApplicationMasterGridData,
      //   "POST",
      //   requestParams
      // );
      // setApplicationData(data);
      // // setApplicationData(data.applicationData); //Commented by mahesh
      // setCount(data.count);
      clearUnwantedLocalStorage();   //deepak gupta
      await GetGridData();
    })();
  }, [start, sortColumn, sortDirection, searchText, count, reset, isactive]);

  const GetGridData = async () => {
    let requestParams = {
      start: start,
      pageSize: pageSize,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      searchText: searchText,
      engagementFilterOption: engagement?.value
        ? engagement?.value?.toString()
        : null,
      activeStatusId: isactive,
    };

    const { data } = await APICall(
      getApplicationMasterGridData,
      "POST",
      requestParams
    );
    setApplicationData(data);
    // setApplicationData(data.applicationData); //Commented by mahesh
    setCount(data[0]?.totalCount);
  };

  useEffect(() => {
    getEngagementData();
  }, []);

  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
        setStart(0);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
    customToolbar: () => {
      return (
        <FormControl sx={{ mt: 1 }}>
          <InputLabel id="demo-simple-select-helper-label">Active</InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            label="Active"
            value={isactive}
            onChange={handleChange}
            sx={{
              width: 80,
              height: 30, // Set the desired height
              "&:focus": { color: "success.main" }, // Change text color to green on focus
            }}
          >
            <MenuItem value={"All"}>All</MenuItem>
            <MenuItem value={"active"}>Yes</MenuItem>
            <MenuItem value={"inactive"}>No</MenuItem>
          </Select>
        </FormControl>
      );
    },
  };

  const handleChange = (event: SelectChangeEvent) => {
    setIsActive(event.target.value);
  };

  const ExportToExcel = async () => {
    axios
      .request({
        responseType: "blob",
        method: "POST",

        //data: Response,
        url: ApplicationExportToExcel,
        //data:JSON,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        data: {
          searchText: searchText,
          sortColumn: sortColumn,
          sortDirection: sortDirection,
          master: "application",
          activeStatusId: isactive,
        },
      })
      .then((response) => {
        fileDownload(response.data, "Application Report.xlsx");
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  };

  const CommonDropdownFunction = async (searchFor, searchValue) => {
    let postObject = {
      searchFor: searchFor,
      searchValue: searchValue,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    return data;
  };

  const onClickFunction = async (action) => {
    if (action === "Submit") {
      await GetGridData();
    } else {
      setEngagement({});
      setReset(!reset);
      localStorage.removeItem("engagement");   //deepak gupta
    }
  };

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "engagement") {
      setEngagement(event);
    }
  };

  const getEngagementData = async () => {
    let engagementId = 1; //hardcoded
    var data = await CommonDropdownFunction(
      "engagementMasterOnly",
      engagementId
    );

    if (data != undefined || data != null) {
      let engagementArray = [];
      await data.map((engagement) => {
        let tempObj = {
          value: engagement.id,
          label: engagement.engagement,
        };
        engagementArray.push(tempObj);
      });

      setApplicationEngagementOption(engagementArray);
    }
    //added by mahesh
    if (data != undefined || data != null) {
      let engagementArray = [];
      await data.map((engagement) => {
        let tempObj = {
          value: engagement.id,
          label: engagement.engagement,
        };
        engagementArray.push(tempObj);
      });

      setApplicationEngagementOption(engagementArray);
    }
  };

  const [toggle, setToggle] = useState(false);
  const toggleFilter = () => {
    setToggle(!toggle);
  };
  //end
  return (
    <>
      <Heading title={"Application Master"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <div>
                <button
                  onClick={() => navigate("edit")}
                  className="btn btn-update"
                >
                  Create
                </button>
              </div>
              <div className="d-flex gap-2">
                <button
                  onClick={() => ExportToExcel()}
                  className="btn btn-export"
                >
                  Export to Excel
                </button>
                <a className="filterIcon" onClick={toggleFilter}>
                  <i className="fa fa-filter"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            {toggle && (
              <div className="row mt-3" id="filterContent">
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Engagement</label>
                    <SelectForm
                      options={applicationEngagementOption}
                      placeholder="Select"
                      isDisabled={false}
                      value={engagement}
                      onChange={(event) => selectOnChange(event, "engagement")}
                      isMulti={false}
                      noIndicator={false}
                      noSeparator={false}
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      onClick={() => onClickFunction("reset")}
                      className="btn btn-reset"
                    >
                      Reset
                    </button>
                    <button
                      onClick={() => onClickFunction("Submit")}
                      className="btn btn-submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="col-lg-12 mt-3">
            <DynamicGrid
              options={options}
              data={applicationData}
              columns={gridColumns}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ApplicationMaster;
